import type { JSX } from 'react'
import type { IActionButtonProps } from '../ActionButton'

import {
  ButtonColors,
  ButtonCorners,
  ButtonFonts,
  ButtonIconSizes,
} from 'atoms/Button'
import { IconNames } from 'atoms/Icon'
import { COLOR, FIXED_INDENTS } from 'vars/index'
import { ActionButton } from '../ActionButton'
import { ButtonBordersWidth } from '../ActionButton.h'

export const SecondaryOpacityFavoriteToggleButton = ({
  disabled,
  selected,
  icon = IconNames.favoriteToggle,
  font = ButtonFonts.FontSmBold,
  colorDefault = ButtonColors.COLOR_PRIMARY,
  colorDisabled = ButtonColors.COLOR_TEXT_TERTIARY,
  backgroundColorDefault = COLOR.SURFACE_OPACITY_LIGHT_10,
  backgroundColorHovered = COLOR.SURFACE_OPACITY_LIGHT_20,
  backgroundColorPressed = COLOR.SURFACE_OPACITY_DARK_25,
  backgroundColorDisabled = COLOR.SURFACE_DARK_5,
  backgroundColorSelectedDefault = COLOR.SURFACE_OPACITY_LIGHT_10,
  backgroundColorSelectedHovered = COLOR.SURFACE_OPACITY_LIGHT_15,
  backgroundColorSelectedPressed = COLOR.SURFACE_OPACITY_LIGHT_20,
  borderWidth = ButtonBordersWidth.BORDER_0,
  paddings = [FIXED_INDENTS.INDENT_30],
  corners = ButtonCorners.CORNERS_PILL,
  onClick,
  iconSize = ButtonIconSizes.xSm,
  ...rest
}: IActionButtonProps): JSX.Element => {
  return (
    <ActionButton
      icon={icon}
      font={font}
      selected={!!selected}
      disabled={!!disabled}
      colorDefault={colorDefault}
      colorDisabled={colorDisabled}
      backgroundColorDefault={backgroundColorDefault}
      backgroundColorDisabled={backgroundColorDisabled}
      backgroundColorHovered={backgroundColorHovered}
      backgroundColorPressed={backgroundColorPressed}
      backgroundColorSelectedPressed={backgroundColorSelectedPressed}
      backgroundColorSelectedHovered={backgroundColorSelectedHovered}
      backgroundColorSelectedDefault={backgroundColorSelectedDefault}
      borderWidth={borderWidth}
      paddings={paddings}
      corners={corners}
      onClick={onClick}
      iconSize={iconSize}
      {...rest}
    />
  )
}
